(function () {
  'use strict';
  if (window.PrintmoProductPageMetrics) return;
  var allowedEvents = new Set(['garment_highlights_rendered', 'product_size_summary_fallback', 'product_color_drawer_open', 'product_size_guide_open', 'product_page_designer_open']);
  function viewportMode() {
    var width = window.innerWidth || document.documentElement.clientWidth || 0;
    return width < 768 ? 'mobile' : width < 1100 ? 'tablet' : 'desktop';
  }
  function clean(payload) {
    var allowed = ['product_handle', 'highlight_count', 'color_sensitive', 'families', 'reason', 'size_count', 'color_count'];
    return allowed.reduce(function (result, key) {
      var value = payload && payload[key];
      if (typeof value === 'boolean' || typeof value === 'number' || (typeof value === 'string' && value.length <= 120)) result[key] = value;
      return result;
    }, {});
  }
  window.PrintmoProductPageMetrics = {
    emit: function (name, payload) {
      if (!allowedEvents.has(name)) return;
      var detail = Object.assign({ event: name, viewport_mode: viewportMode() }, clean(payload));
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(detail);
      document.dispatchEvent(new CustomEvent('pm:product-page-metric', { detail: detail }));
    }
  };
})();
